import { useEffect, useState } from 'react';
import {Route, Routes, useParams} from 'react-router-dom'
import {Request} from './components/Request'
import { useLang, setLanguage } from '../../../_metronic/i18n/Metronici18n'

const RequestWithLanguageCode = () => {
  const [languageChecked, setLanguageChecked ] = useState(false)
  const { languageCode } = useParams<{ languageCode: string }>()
  const selectedLang = useLang()

  useEffect(() => {
    if (languageCode) {
      if( selectedLang != languageCode){
        setLanguage(languageCode)
      }
    }
    setLanguageChecked(true)
  }, [selectedLang, languageCode]);

  return languageChecked && selectedLang === languageCode ? <Request /> : <span></span>
}

const APIAccessPage = () => (
  <Routes>
    <Route index element={<Request />} />
    <Route path=':languageCode' element={<RequestWithLanguageCode />} />
  </Routes>
)

export {APIAccessPage}
